var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-preview-navbar",attrs:{"data-testid":"product-preview-navbar"}},[_c('PriceTag',{staticClass:"qrw-label-md bold qrw-text-content-base-primary",attrs:{"value":_vm.total}}),_c('div',{staticClass:"qrw-text-content-base-tertiary qrw-label-sm"},[_vm._v(" "+_vm._s(_vm.$t('preview.product_navbar'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }